import { render, staticRenderFns } from "./LoginDealRefundSetting.vue?vue&type=template&id=00ce40a5&scoped=true&"
import script from "./LoginDealRefundSetting.vue?vue&type=script&lang=js&"
export * from "./LoginDealRefundSetting.vue?vue&type=script&lang=js&"
import style0 from "./LoginDealRefundSetting.vue?vue&type=style&index=0&id=00ce40a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ce40a5",
  null
  
)

export default component.exports